import Vue from 'vue'
import App from './App.vue'
import download from './js/download.js'
new Vue({
  el: '#app',
  render: h => h(App),

})







// WEBPACK FOOTER //
// ./src/main.js